import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import { ButtonStyleAzul, ButtonStyleWhite, CentrarDiv, CssTextField, CustomBackdrop, DivBackground, PaperStyle, SpacingDiv, TEXT_COLOR_AZUL_OSCURO, TEXT_COLOR_CELESTE, TypographyStyle, TypographyStyleSecundary } from '../../styles/Styles';
// import '../../styles/globalCss.css';
// import { postLogin } from '../../api/api';
import { useDispatch } from 'react-redux';
import { setToken } from '../../redux/actions/action';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Alert, Box, Backdrop, Button, CircularProgress, Container, CssBaseline, IconButton, InputAdornment, Paper, Snackbar, Typography, ListItem, ListItemButton, ListItemText, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { postLogin, VERSION_APP } from '../../api/Api';
import { LogoSicoop } from '../../components/logos/LogoImg';
import SplashIcon from '../../splash/SplashIcon';
import { MESSAGE_ERROR } from '../../components/constantes';
import { handleDispositivo } from '../../components/hooks/HooksGlobal';



function LoginPage({ }) {
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [mensaje, setMensaje] = useState('');
    const [cargando, setCargando] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [splasVisible, setSplasVisible] = useState(true);
    const [dataInputs, setDataInputs] = useState([
        {
            title: 'Usuario',
            type: 'text',
            titlesecundary: 'Sin definir',
            active: true
        },
        {
            title: 'Código de Comercio',
            type: 'number',
            titlesecundary: 'Sin definir',
            active: true
        },
        {
            title: 'Contraseña',
            type: 'password',
            titlesecundary: 'Sin definir',
            active: true
        },
        {
            title: 'Razón Social',
            type: 'text',
            titlesecundary: 'Sin definir',
            active: false
        },
        {
            title: 'Nombre Fantasía',
            type: 'text',
            titlesecundary: 'Sin definir',
            active: false
        }
    ]);


    useEffect(() => {
        if (localStorage.getItem('biometric')) {
            handleSesionAppBiometric();
        }
    }, [])


    const dispatch = useDispatch();

    //---------------------------------ruta de redireccion
    let history = useNavigate();

    //agregar el title a la pagina
    document.title = "Sicoop Comercios";

    useEffect(() => {
        setTimeout(() => {
            setSplasVisible(false);
        }, 2000);
    }, [])


    //---------------------------------cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };







    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleEnventoInput = (text, index, id) => {
        //utilizar prevstate para actualizar el valor del array, y luego actualizar el estado
        setDataInputs(prevState => {
            const list = [...prevState];
            list[index].titlesecundary = text;

            return list;
        });

    }


    const handleSesionAppBiometric = () => {
        try {
            // window.Android.getPhoto();
            window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'biometric', data: true }));
        } catch (e) {
            console.error('Error en biometric:', e);
        }
        // const readQrFromApp = new Event('uploadPhoto');
        // window.addEventListener('uploadPhoto', handleTakePhoto, { once: true });

        if (handleDispositivo() === 'Android') {
            document.addEventListener("message", function (event) {
                // handleTakePhoto(JSON.parse(event.data));
                handleGuardarBiometric(JSON.parse(event.data));
            });
        }
        // //RECIBIR EL EVENTO DE REACT NATIVE SI ES IOS
        // if (isMobileIos) {
        //   window.addEventListener("message", function (event) {
        //     handleTakePhoto(JSON.parse(event.data));
        //   });
        // }
    }

    const handleGuardarBiometric = (item) => {
        //desencriptar el body y setearlo al body
        let dataDesencriptada = atob(item);
        //pasar a json el body
        dataDesencriptada = JSON.parse(dataDesencriptada);


        setCargando(true);

        postLogin(dataDesencriptada)
            .then(response => {
                setCargando(false);
                const { data } = response;

                console.log('response', data)
                if (data.codReturn === "1") {
                    setOpen(true);
                    setSeverity('success');
                    setMensaje(data.txtReturn);

                    //setear body.comercio en el localstorage con data.data
                    let dataStorage = data.data;
                    dataStorage.codeComercio = dataDesencriptada.comercio;
                    dataStorage.userName = dataDesencriptada.userName;
                    localStorage.setItem('dataUser', JSON.stringify(dataStorage));

                    //encriptar el body y setearlo en el localstorage
                    let dataAutenticacion = dataDesencriptada;
                    //encryptar el body y setearlo en el localstorage
                    let dataEncriptada = btoa(JSON.stringify(dataAutenticacion));

                    localStorage.setItem('dataAutenticacion', JSON.stringify(dataEncriptada));

                    dispatch(setToken(dataStorage));
                    // if (handleDispositivo() === 'Android') {
                    //     handleTokenNotificacion();
                    // }


                } else {
                    setCargando(false);
                    setOpen(true);
                    setSeverity('error');
                    setMensaje(data.txtReturn);
                }

            })
            .catch(error => {
                console.log("errorSesion", error);
                setOpen(true);
                setSeverity('error');
                setMensaje(MESSAGE_ERROR);
                setCargando(false);
            })
    }

    //funcion para enviar el token de notificacion al backend
    const handleTokenNotificacion = () => {
        try {
            // window.Android.getPhoto();
            window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'notificacionToken', data: true }));
        } catch (e) {
            console.error('Error en handleTokenNotificacion:', e);
        }

        if (handleDispositivo() === 'Android') {
            document.addEventListener("message", function (event) {
                let body = {};
                body = JSON.parse(event.data);
                // alert(JSON.stringify(body));
                localStorage.setItem('tokenNotificacion', JSON.stringify(body));
            });
        }

        // //RECIBIR EL EVENTO DE REACT NATIVE SI ES IOS
        // if (handleDispositivo() === 'IOS') {
        //   window.addEventListener("message", function (event) {
        //     let body = {};
        //     body = JSON.parse(event.data);
        //     // alert(JSON.stringify(body));
        //     localStorage.setItem('tokenNotificacion', JSON.stringify(body));
        //   });
        // }
    }

    const handleGuardar = () => {
        let body = {};
        body.userName = dataInputs[0].titlesecundary;
        body.comercio = dataInputs[1].titlesecundary;
        body.userPassword = dataInputs[2].titlesecundary;


        console.log('body', body)
        if (body.userName.trim() === '' || body.comercio.trim() === '' || body.userPassword.trim() === '' || body.userName === 'Sin definir' || body.comercio === 'Sin definir' || body.userPassword === 'Sin definir') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('Complete todos los campos');
        } else {
            setCargando(true);

            // localStorage.setItem('dataUser', JSON.stringify(body));

            // dispatch(setToken(body));

            postLogin(body)
                .then(response => {
                    setCargando(false);
                    const { data } = response;

                    console.log('response', data)
                    if (data.codReturn === "1") {
                        setOpen(true);
                        setSeverity('success');
                        setMensaje(data.txtReturn);
                        //limpiar state de dataInputs con prevstate
                        setDataInputs(prevState => {
                            const list = [...prevState];
                            list[0].titlesecundary = 'Sin definir';
                            list[1].titlesecundary = 'Sin definir';
                            list[2].titlesecundary = 'Sin definir';
                            return list;
                        });

                        //setear body.comercio en el localstorage con data.data
                        let dataStorage = data.data;
                        dataStorage.codeComercio = body.comercio;
                        dataStorage.userName = body.userName;
                        localStorage.setItem('dataUser', JSON.stringify(dataStorage));
                        dispatch(setToken(dataStorage));

                        if (handleDispositivo() === 'Android') {
                            //encriptar el body y setearlo en el localstorage
                            let dataAutenticacion = body;
                            //encryptar el body y setearlo en el localstorage
                            let dataEncriptada = btoa(JSON.stringify(dataAutenticacion));

                            localStorage.setItem('dataAutenticacion', JSON.stringify(dataEncriptada));
                        }

                        // if (handleDispositivo() === 'Android' || handleDispositivo() === 'IOS') {
                        //     handleTokenNotificacion();
                        // }



                    } else {
                        setCargando(false);
                        setOpen(true);
                        setSeverity('error');
                        setMensaje(data.txtReturn);
                    }

                })
                .catch(error => {
                    console.log("errorSesion", error);
                    setOpen(true);
                    setSeverity('error');
                    setMensaje(MESSAGE_ERROR);
                    setCargando(false);
                })
        }
    }

    // if (splasVisible) {
    //     return (<SplashIcon />)
    // }





    return (
        <DivBackground style={{ height: '100vh' }}>
            {/* <CentrarDiv> */}
            <div style={{
                alignContent: 'center',
                justifyContent: 'center',
                display: 'flex',

            }}>
                <LogoSicoop tamano={200} />
            </div>

            <Container component="main" maxWidth="xs">
                <CssBaseline />

                <PaperStyle>
                    <TypographyStyleSecundary
                        variant="h6"
                        color={TEXT_COLOR_CELESTE}
                    >
                        Iniciar sesión con tu cuenta
                    </TypographyStyleSecundary>

                    <TypographyStyleSecundary
                        style={{ marginBottom: 20, color: '#787e8e' }}
                        variant="body2"
                    >
                        Completa con tus datos para iniciar.
                    </TypographyStyleSecundary>

                    <SpacingDiv>
                        <CssTextField
                            label="Usuario"
                            variant="outlined"
                            fullWidth
                            onChange={(e) => handleEnventoInput(e.target.value.trim(), 0)}
                            value={dataInputs[0].titlesecundary === 'Sin definir' ? '' : dataInputs[0].titlesecundary}
                        />
                    </SpacingDiv>

                    <SpacingDiv>
                        <CssTextField
                            label="Código de comercio"
                            variant="outlined"
                            fullWidth
                            // onChange={(e) => handleEnventoInput(e.target.value.trim(), 1)}
                            //solo admite numeros
                            onChange={(e) => handleEnventoInput(e.target.value.replace(/[^0-9]/g, ''), 1)}
                            value={dataInputs[1].titlesecundary === 'Sin definir' ? '' : dataInputs[1].titlesecundary}
                        />
                    </SpacingDiv>

                    <SpacingDiv style={{ marginBottom: 10 }}>
                        <CssTextField
                            label="Contraseña"
                            variant="outlined"
                            fullWidth
                            onChange={(e) => handleEnventoInput(e.target.value, 2)}
                            value={dataInputs[2].titlesecundary === 'Sin definir' ? '' : dataInputs[2].titlesecundary}
                            type={showPassword ? 'text' : 'password'}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                        >
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            //evento onKeyPress para que al presionar enter se ejecute handleGuardar
                            onKeyDown={(ev) => {
                                if (ev.key === 'Enter') {
                                    handleGuardar();
                                    ev.preventDefault();
                                }
                            }}
                        />
                    </SpacingDiv>



                    <div style={{}}>
                        <ButtonStyleAzul
                            variant="contained"
                            style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: '10px'
                            }}
                            onClick={handleGuardar}
                        >
                            Iniciar Sesión
                        </ButtonStyleAzul>
                    </div>

                    <Box
                        mt={2}
                        textAlign="center"
                    >
                        <Typography
                            variant="body2"
                            // color="textSecondary"
                            style={{ color: '#444444', fontSize: '12px' }}
                        >
                            Versión {VERSION_APP}
                        </Typography>
                    </Box>
                </PaperStyle>



            </Container>
            {/* </CentrarDiv> */}

            <Snackbar open={open} autoHideDuration={10000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={severity}
                    elevation={6}
                // variant="filled"
                >
                    {mensaje}
                </Alert>
            </Snackbar>

            <CustomBackdrop open={cargando}>
                <CircularProgress color="inherit" />
            </CustomBackdrop>
        </DivBackground>
    )
}

export default LoginPage;